import Icon from '@ant-design/icons';

import { ReactComponent as PieChartSVG } from '../svg/pie-chart.svg';
import { ReactComponent as InboxSVG } from '../svg/inbox.svg';
import { ReactComponent as LayoutSVG } from '../svg/layout.svg';
import { ReactComponent as PeopleSVG } from '../svg/people.svg';
import { ReactComponent as LogSVG } from '../svg/log.svg';
import { ReactComponent as SettingSVG } from '../svg/setting.svg';
import { ReactComponent as ArrowHeadLeftSVG } from '../svg/arrow-head-left.svg';
import { ReactComponent as UploadSVG } from '../svg/upload.svg';
import { ReactComponent as DownloadSVG } from '../svg/download.svg';
import { ReactComponent as CodeDownloadSVG } from '../svg/code-download.svg';
import { ReactComponent as InfoSVG } from '../svg/info.svg';
import { ReactComponent as CloseSVG } from '../svg/close.svg';
import { ReactComponent as BoldSVG } from '../svg/bold.svg';
import { ReactComponent as CodeSVG } from '../svg/code.svg';
import { ReactComponent as AlignLeft } from '../svg/align-left.svg';
import { ReactComponent as AlignCenter } from '../svg/align-center.svg';
import { ReactComponent as AlignRight } from '../svg/align-right.svg';
import { ReactComponent as OpenSVG } from '../svg/open.svg';
import { CustomIconComponentProps } from '@ant-design/icons/lib/components/Icon';
import { CustomSVGBaseType } from 'global';

interface SvgIconBaseProps {
  isActive?: boolean;
  className?: string;
  onClick?: () => void;
  color?: string;
}
export const PieChartIcon: React.FC<CustomIconComponentProps> = (props) => (
  <Icon component={PieChartSVG} {...props} />
);

export const InboxIcon: React.FC<CustomIconComponentProps> = (props) => (
  <Icon component={InboxSVG} {...props} />
);

export const LayoutIcon: React.FC<CustomIconComponentProps> = (props) => (
  <Icon component={LayoutSVG} {...props} />
);

export const PeopleIcon: React.FC<CustomIconComponentProps> = (props) => (
  <Icon component={PeopleSVG} {...props} />
);

export const LogIcon: React.FC<CustomIconComponentProps> = (props) => (
  <Icon component={LogSVG} {...props} />
);

export const SettingIcon: React.FC<CustomIconComponentProps> = (props) => (
  <Icon component={SettingSVG} {...props} />
);

export const ArrowHeadLeftIcon: React.FC<CustomIconComponentProps> = (
  props,
) => <Icon component={ArrowHeadLeftSVG} {...props} />;

export const UploadIcon: React.FC<CustomIconComponentProps> = (props) => (
  <Icon component={UploadSVG} {...props} />
);

export const DownloadIcon: React.FC<CustomIconComponentProps> = (props) => (
  <Icon component={DownloadSVG} {...props} />
);

export const CodeDownloadIcon: React.FC<CustomIconComponentProps> = (props) => (
  <Icon component={CodeDownloadSVG} {...props} />
);

export const InfoIcon: React.FC<CustomIconComponentProps> = (props) => (
  <Icon component={InfoSVG} {...props} />
);

export const CloseIcon: React.FC<CustomIconComponentProps> = (props) => (
  <Icon component={CloseSVG} {...props} />
);

export const BoldIcon: React.FC<CustomIconComponentProps> = (props) => (
  <Icon component={BoldSVG} {...props} />
);

export const CodeIcon: React.FC<CustomIconComponentProps> = (props) => (
  <Icon component={CodeSVG} {...props} />
);

export const AlignLeftIcon: React.FC<CustomIconComponentProps> = (props) => (
  <Icon component={AlignLeft} {...props} />
);

export const AlignCenterIcon: React.FC<CustomIconComponentProps> = (props) => (
  <Icon component={AlignCenter} {...props} />
);

export const AlignRightIcon: React.FC<CustomIconComponentProps> = (props) => (
  <Icon component={AlignRight} {...props} />
);

export const TripManagementIcon: React.FC<CustomSVGBaseType> = ({
  className,
}) => (
  <svg
    width="18"
    className={className}
    height="19"
    viewBox="0 0 18 19"
    fill="currentcolor"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M16 0.765625H2C0.9 0.765625 0 1.66562 0 2.76562V16.7656C0 17.8656 0.9 18.7656 2 18.7656H16C17.1 18.7656 18 17.8656 18 16.7656V2.76562C18 1.66562 17.1 0.765625 16 0.765625ZM16 16.7656H2V2.76562H16V16.7656ZM4 7.76562H6V14.7656H4V7.76562ZM8 4.76562H10V14.7656H8V4.76562ZM12 10.7656H14V14.7656H12V10.7656Z"
      fill="currentcolor"
    />
  </svg>
);

export const ListIcon: React.FC<CustomSVGBaseType> = ({ className }) => (
  <svg
    width="18"
    height="11"
    className={className}
    viewBox="0 0 18 11"
    fill="currentcolor"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M0 6.76562H2V4.76562H0V6.76562ZM0 10.7656H2V8.76562H0V10.7656ZM0 2.76562H2V0.765625H0V2.76562ZM4 6.76562H18V4.76562H4V6.76562ZM4 10.7656H18V8.76562H4V10.7656ZM4 0.765625V2.76562H18V0.765625H4ZM0 6.76562H2V4.76562H0V6.76562ZM0 10.7656H2V8.76562H0V10.7656ZM0 2.76562H2V0.765625H0V2.76562ZM4 6.76562H18V4.76562H4V6.76562ZM4 10.7656H18V8.76562H4V10.7656ZM4 0.765625V2.76562H18V0.765625H4Z"
      fill="currentcolor"
    />
  </svg>
);

export const CreateTripIcon: React.FC<CustomSVGBaseType> = ({ className }) => (
  <svg
    width="20"
    height="21"
    className={className}
    viewBox="0 0 20 21"
    fill="currentcolor"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M2 4.76562H0V18.7656C0 19.8656 0.9 20.7656 2 20.7656H16V18.7656H2V4.76562ZM18 0.765625H6C4.9 0.765625 4 1.66562 4 2.76562V14.7656C4 15.8656 4.9 16.7656 6 16.7656H18C19.1 16.7656 20 15.8656 20 14.7656V2.76562C20 1.66562 19.1 0.765625 18 0.765625ZM18 14.7656H6V2.76562H18V14.7656ZM11 12.7656H13V9.76562H16V7.76562H13V4.76562H11V7.76562H8V9.76562H11V12.7656Z"
      fill="currentcolor"
    />
  </svg>
);

export const UserTripIcon: React.FC<CustomSVGBaseType> = ({ className }) => (
  <svg
    width="20"
    height="18"
    className={className}
    viewBox="0 0 20 18"
    fill="currentcolor"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M2.08496 14.2656V13.6156C2.08496 13.2756 2.24496 12.9556 2.49496 12.8056C4.18496 11.7956 6.11496 11.2656 8.08496 11.2656C8.11496 11.2656 8.13496 11.2656 8.16496 11.2756C8.26496 10.5756 8.46496 9.90562 8.75496 9.29562C8.53496 9.27562 8.31496 9.26562 8.08496 9.26562C5.66496 9.26562 3.40496 9.93563 1.47496 11.0856C0.594961 11.6056 0.0849609 12.5856 0.0849609 13.6156V16.2656H9.34496C8.92496 15.6656 8.59496 14.9856 8.37496 14.2656H2.08496Z"
      fill="currentcolor"
    />
    <path
      d="M8.08496 8.26562C10.295 8.26562 12.085 6.47563 12.085 4.26562C12.085 2.05562 10.295 0.265625 8.08496 0.265625C5.87496 0.265625 4.08496 2.05562 4.08496 4.26562C4.08496 6.47563 5.87496 8.26562 8.08496 8.26562ZM8.08496 2.26562C9.18496 2.26562 10.085 3.16563 10.085 4.26562C10.085 5.36562 9.18496 6.26562 8.08496 6.26562C6.98496 6.26562 6.08496 5.36562 6.08496 4.26562C6.08496 3.16563 6.98496 2.26562 8.08496 2.26562Z"
      fill="currentcolor"
    />
    <path
      d="M18.835 12.2656C18.835 12.0456 18.805 11.8456 18.775 11.6356L19.915 10.6256L18.915 8.89563L17.465 9.38562C17.145 9.11562 16.785 8.90562 16.385 8.75562L16.085 7.26562H14.085L13.785 8.75562C13.385 8.90562 13.025 9.11562 12.705 9.38562L11.255 8.89563L10.255 10.6256L11.395 11.6356C11.365 11.8456 11.335 12.0456 11.335 12.2656C11.335 12.4856 11.365 12.6856 11.395 12.8956L10.255 13.9056L11.255 15.6356L12.705 15.1456C13.025 15.4156 13.385 15.6256 13.785 15.7756L14.085 17.2656H16.085L16.385 15.7756C16.785 15.6256 17.145 15.4156 17.465 15.1456L18.915 15.6356L19.915 13.9056L18.775 12.8956C18.805 12.6856 18.835 12.4856 18.835 12.2656ZM15.085 14.2656C13.985 14.2656 13.085 13.3656 13.085 12.2656C13.085 11.1656 13.985 10.2656 15.085 10.2656C16.185 10.2656 17.085 11.1656 17.085 12.2656C17.085 13.3656 16.185 14.2656 15.085 14.2656Z"
      fill="currentcolor"
    />
  </svg>
);

export const StoresIcon: React.FC<CustomSVGBaseType> = ({ className }) => (
  <svg
    width="24"
    height="25"
    className={className}
    viewBox="0 0 24 25"
    fill="currentcolor"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M16.5463 13.7656C17.2963 13.7656 17.9563 13.3556 18.2963 12.7356L21.8763 6.24563C22.2463 5.58562 21.7663 4.76562 21.0063 4.76562H6.20634L5.26634 2.76562H1.99634V4.76562H3.99634L7.59634 12.3556L6.24634 14.7956C5.51634 16.1356 6.47634 17.7656 7.99634 17.7656H19.9963V15.7656H7.99634L9.09634 13.7656H16.5463ZM7.15634 6.76562H19.3063L16.5463 11.7656H9.52634L7.15634 6.76562ZM7.99634 18.7656C6.89634 18.7656 6.00634 19.6656 6.00634 20.7656C6.00634 21.8656 6.89634 22.7656 7.99634 22.7656C9.09634 22.7656 9.99634 21.8656 9.99634 20.7656C9.99634 19.6656 9.09634 18.7656 7.99634 18.7656ZM17.9963 18.7656C16.8963 18.7656 16.0063 19.6656 16.0063 20.7656C16.0063 21.8656 16.8963 22.7656 17.9963 22.7656C19.0963 22.7656 19.9963 21.8656 19.9963 20.7656C19.9963 19.6656 19.0963 18.7656 17.9963 18.7656Z"
      fill="currentcolor"
    />
  </svg>
);

export const MenuIcon: React.FC<CustomSVGBaseType> = ({ className }) => (
  <svg
    width="6"
    height="12"
    className={className}
    viewBox="0 0 8 15"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M1 13.7656L7 7.76562L1 1.76562"
      stroke="currentcolor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export const NotiIcon: React.FC<CustomSVGBaseType> = ({ className }) => (
  <svg
    width="18"
    height="21"
    className={className}
    viewBox="0 0 18 21"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M15.7201 11.3997L17.5201 13.2097C17.9824 13.6796 18.1183 14.3807 17.8652 14.9893C17.6122 15.598 17.0193 15.996 16.3601 15.9997H13.0001V16.3397C12.9029 18.4534 11.1141 20.0901 9.00012 19.9997C6.88614 20.0901 5.09737 18.4534 5.00012 16.3397V15.9997H1.64012C0.980951 15.996 0.38806 15.598 0.134995 14.9893C-0.11807 14.3807 0.0178793 13.6796 0.480117 13.2097L2.28012 11.3997V6.72969C2.28366 4.79086 3.12196 2.94745 4.58084 1.67045C6.03973 0.393448 7.97788 -0.193455 9.90012 0.0596897C13.2856 0.578576 15.7696 3.51503 15.7201 6.93969V11.3997ZM9.00012 17.9997C10.0035 18.0705 10.8849 17.339 11.0001 16.3397V15.9997H7.00012V16.3397C7.11533 17.339 7.99671 18.0705 9.00012 17.9997Z"
      fill="#637381"
    />
  </svg>
);

export const SettingMenuIcon: React.FC<CustomSVGBaseType> = ({ className }) => (
  <svg
    width="20"
    height="20"
    className={className}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M17.23 7.37H18.32C19.2495 7.3755 20 8.13053 20 9.06V11C19.9952 11.901 19.2805 12.6378 18.38 12.67H17.29C17.1589 12.6811 17.046 12.7667 17 12.89C16.927 13.0025 16.927 13.1475 17 13.26L17.73 13.99C18.0457 14.3035 18.2233 14.7301 18.2233 15.175C18.2233 15.6199 18.0457 16.0465 17.73 16.36L16.39 17.7C16.0801 18.0189 15.6546 18.1991 15.21 18.2C14.7635 18.1941 14.3367 18.0148 14.02 17.7L13.26 16.93C13.1475 16.857 13.0025 16.857 12.89 16.93C12.74 16.99 12.63 17.09 12.63 17.23V18.32C12.6245 19.2495 11.8695 20 10.94 20H9.05C8.1451 20.0006 7.40232 19.2843 7.37 18.38V17.29C7.35895 17.1589 7.27326 17.046 7.15 17C7.02506 16.9199 6.86494 16.9199 6.74 17L5.97 17.74C5.65648 18.0557 5.22994 18.2333 4.785 18.2333C4.34006 18.2333 3.91352 18.0557 3.6 17.74L2.26 16.38C1.93962 16.067 1.75931 15.6379 1.76 15.19C1.76586 14.7435 1.94517 14.3167 2.26 14L3.07 13.26C3.14298 13.1475 3.14298 13.0025 3.07 12.89C3.01 12.74 2.91 12.63 2.77 12.63H1.68C0.750546 12.6245 -1.62718e-05 11.8695 0 10.94V9.05C0 8.12216 0.752162 7.37 1.68 7.37H2.71C2.84109 7.35895 2.95403 7.27326 3 7.15C3.08005 7.02506 3.08005 6.86494 3 6.74L2.26 6C1.93494 5.68539 1.75142 5.25237 1.75142 4.8C1.75142 4.34763 1.93494 3.91461 2.26 3.6L3.63 2.26C3.9399 1.94115 4.36536 1.76087 4.81 1.76C5.25653 1.76586 5.68328 1.94517 6 2.26L6.74 3.07C6.85254 3.14298 6.99746 3.14298 7.11 3.07C7.26 3.01 7.37 2.91 7.37 2.77V1.68C7.3755 0.750546 8.13053 -1.62718e-05 9.06 0H11C11.9083 0.0270433 12.6304 0.771342 12.63 1.68V2.71C12.6411 2.84109 12.7267 2.95403 12.85 3C12.9749 3.08005 13.1351 3.08005 13.26 3L14.03 2.26C14.3435 1.94428 14.7701 1.76672 15.215 1.76672C15.6599 1.76672 16.0865 1.94428 16.4 2.26L17.74 3.63C18.0594 3.94362 18.2396 4.37235 18.24 4.82C18.2414 5.2651 18.0608 5.69143 17.74 6L16.93 6.74C16.857 6.85254 16.857 6.99746 16.93 7.11C16.99 7.26 17.09 7.37 17.23 7.37ZM6.76642 11.3394C7.30816 12.6473 8.58438 13.5 10 13.5C11.933 13.5 13.5 11.933 13.5 10C13.5 8.58438 12.6473 7.30816 11.3394 6.76642C10.0315 6.22469 8.52612 6.52413 7.52513 7.52513C6.52413 8.52612 6.22469 10.0315 6.76642 11.3394Z"
      fill="#637381"
    />
  </svg>
);

export const FinanceIcon: React.FC<CustomSVGBaseType> = ({ className }) => (
  <svg
    width="24"
    height="25"
    className={className}
    viewBox="0 0 24 25"
    fill="currentcolor"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12 2.76562C6.48 2.76562 2 7.24563 2 12.7656C2 18.2856 6.48 22.7656 12 22.7656C17.52 22.7656 22 18.2856 22 12.7656C22 7.24563 17.52 2.76562 12 2.76562ZM12 20.7656C7.59 20.7656 4 17.1756 4 12.7656C4 8.35563 7.59 4.76562 12 4.76562C16.41 4.76562 20 8.35563 20 12.7656C20 17.1756 16.41 20.7656 12 20.7656ZM12.31 11.9056C10.54 11.4556 9.97 10.9656 9.97 10.2356C9.97 9.39563 10.76 8.80562 12.07 8.80562C13.45 8.80562 13.97 9.46563 14.01 10.4456H15.72C15.67 9.10563 14.85 7.87563 13.23 7.47563V5.76562H10.9V7.45563C9.39 7.77563 8.18 8.75563 8.18 10.2656C8.18 12.0556 9.67 12.9556 11.84 13.4756C13.79 13.9356 14.18 14.6256 14.18 15.3456C14.18 15.8756 13.79 16.7356 12.08 16.7356C10.48 16.7356 9.85 16.0156 9.76 15.0956H8.04C8.14 16.7956 9.4 17.7556 10.9 18.0656V19.7656H13.24V18.0956C14.76 17.8056 15.96 16.9356 15.97 15.3256C15.96 13.1256 14.07 12.3656 12.31 11.9056Z"
      fill="currentcolor"
    />
  </svg>
);

export const TurnOverIcon: React.FC<CustomSVGBaseType> = ({ className }) => (
  <svg
    width="24"
    height="25"
    className={className}
    viewBox="0 0 24 25"
    fill="currentcolor"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M20.8387 8.16727C21.2287 7.77727 21.2287 7.14727 20.8387 6.75727L18.0087 3.92727C17.6187 3.53727 16.9887 3.53727 16.5987 3.92727L12.1087 8.41727L8.21865 4.52727C7.43865 3.74727 6.16865 3.74727 5.38865 4.52727L3.48865 6.42727C2.70865 7.20727 2.70865 8.47727 3.48865 9.25727L7.37865 13.1473L2.86865 17.6573V21.8973H7.10865L11.6287 17.3773L15.5187 21.2673C16.4687 22.2173 17.7487 21.8673 18.3487 21.2673L20.2487 19.3673C21.0287 18.5873 21.0287 17.3173 20.2487 16.5373L16.3587 12.6473L20.8387 8.16727ZM4.90865 7.83727L6.79865 5.93727L8.06865 7.20727L6.88865 8.39727L8.29865 9.80727L9.48865 8.61727L10.6887 9.81727L8.78865 11.7173L4.90865 7.83727ZM16.1387 15.2773L14.9487 16.4673L16.3587 17.8773L17.5487 16.6873L18.8187 17.9573L16.9187 19.8573L13.0287 15.9673L14.9287 14.0673L16.1387 15.2773ZM6.27865 19.8973H4.86865V18.4873L14.4787 8.87727L15.8887 10.2873L6.27865 19.8973ZM15.8887 7.45727L17.2987 6.04727L18.7087 7.45727L17.2987 8.86727L15.8887 7.45727Z"
      fill="currentcolor"
    />
  </svg>
);

export const StatementIcon: React.FC<CustomSVGBaseType> = ({ className }) => (
  <svg
    width="24"
    height="25"
    className={className}
    viewBox="0 0 24 25"
    fill="currentcolor"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M4.08496 18.2656V17.6156C4.08496 17.2756 4.24496 16.9556 4.49496 16.8056C6.18496 15.7956 8.11496 15.2656 10.085 15.2656C10.115 15.2656 10.135 15.2656 10.165 15.2756C10.265 14.5756 10.465 13.9056 10.755 13.2956C10.535 13.2756 10.315 13.2656 10.085 13.2656C7.66496 13.2656 5.40496 13.9356 3.47496 15.0856C2.59496 15.6056 2.08496 16.5856 2.08496 17.6156V20.2656H11.345C10.925 19.6656 10.595 18.9856 10.375 18.2656H4.08496Z"
      fill="currentcolor"
    />
    <path
      d="M10.085 12.2656C12.295 12.2656 14.085 10.4756 14.085 8.26562C14.085 6.05562 12.295 4.26562 10.085 4.26562C7.87496 4.26562 6.08496 6.05562 6.08496 8.26562C6.08496 10.4756 7.87496 12.2656 10.085 12.2656ZM10.085 6.26562C11.185 6.26562 12.085 7.16563 12.085 8.26562C12.085 9.36562 11.185 10.2656 10.085 10.2656C8.98496 10.2656 8.08496 9.36562 8.08496 8.26562C8.08496 7.16563 8.98496 6.26562 10.085 6.26562Z"
      fill="currentcolor"
    />
    <path
      d="M20.835 16.2656C20.835 16.0456 20.805 15.8456 20.775 15.6356L21.915 14.6256L20.915 12.8956L19.465 13.3856C19.145 13.1156 18.785 12.9056 18.385 12.7556L18.085 11.2656H16.085L15.785 12.7556C15.385 12.9056 15.025 13.1156 14.705 13.3856L13.255 12.8956L12.255 14.6256L13.395 15.6356C13.365 15.8456 13.335 16.0456 13.335 16.2656C13.335 16.4856 13.365 16.6856 13.395 16.8956L12.255 17.9056L13.255 19.6356L14.705 19.1456C15.025 19.4156 15.385 19.6256 15.785 19.7756L16.085 21.2656H18.085L18.385 19.7756C18.785 19.6256 19.145 19.4156 19.465 19.1456L20.915 19.6356L21.915 17.9056L20.775 16.8956C20.805 16.6856 20.835 16.4856 20.835 16.2656ZM17.085 18.2656C15.985 18.2656 15.085 17.3656 15.085 16.2656C15.085 15.1656 15.985 14.2656 17.085 14.2656C18.185 14.2656 19.085 15.1656 19.085 16.2656C19.085 17.3656 18.185 18.2656 17.085 18.2656Z"
      fill="currentcolor"
    />
  </svg>
);
export const MapIcon: React.FC<CustomSVGBaseType> = ({ className }) => (
  <svg
    className={className}
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M20.5 3L20.34 3.03L15 5.1L9 3L3.36 4.9C3.15 4.97 3 5.15 3 5.38V20.5C3 20.78 3.22 21 3.5 21L3.66 20.97L9 18.9L15 21L20.64 19.1C20.85 19.03 21 18.85 21 18.62V3.5C21 3.22 20.78 3 20.5 3ZM10 5.47L14 6.87V18.53L10 17.13V5.47ZM5 6.46L8 5.45V17.15L5 18.31V6.46ZM19 17.54L16 18.55V6.86L19 5.7V17.54Z"
      fill="#7A7B7A"
    />
  </svg>
);
export const PlusIcon: React.FC<CustomSVGBaseType> = ({ className }) => (
  <svg
    className={className}
    width="25"
    height="24"
    viewBox="0 0 25 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12.3871 5V19"
      stroke="#212121"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M5.38708 12H19.3871"
      stroke="#212121"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export const ChatIcon: React.FC<CustomSVGBaseType> = ({ className }) => (
  <svg
    className={className}
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M15.6667 0.796875H2.33341C1.41675 0.796875 0.666748 1.54688 0.666748 2.46354V17.4635L4.00008 14.1302H15.6667C16.5834 14.1302 17.3334 13.3802 17.3334 12.4635V2.46354C17.3334 1.54688 16.5834 0.796875 15.6667 0.796875ZM15.6667 12.4635H4.00008L2.33341 14.1302V2.46354H15.6667V12.4635ZM4.83341 6.63021H6.50008V8.29688H4.83341V6.63021ZM8.16675 6.63021H9.83342V8.29688H8.16675V6.63021ZM11.5001 6.63021H13.1667V8.29688H11.5001V6.63021Z"
      fill="#B4B9B9"
    />
  </svg>
);
export const SmileIcon: React.FC<CustomSVGBaseType> = ({ className }) => (
  <svg
    className={className}
    width="20"
    height="21"
    viewBox="0 0 20 21"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_110_88821)">
      <path
        d="M9.9999 0.53125C7.45382 0.53125 5.01203 1.54268 3.21168 3.34302C1.41133 5.14337 0.399902 7.58517 0.399902 10.1313C0.399968 11.3919 0.648344 12.6403 1.13085 13.805C1.61336 14.9697 2.32054 16.0279 3.21203 16.9193C4.10352 17.8107 5.16185 18.5178 6.3266 19.0002C7.49135 19.4826 8.73971 19.7308 10.0004 19.7308C11.2611 19.7307 12.5094 19.4823 13.6741 18.9998C14.8388 18.5173 15.8971 17.8101 16.7885 16.9186C17.6799 16.0271 18.387 14.9688 18.8693 13.804C19.3517 12.6393 19.6 11.3909 19.5999 10.1302C19.5999 4.82925 15.3009 0.53125 9.9999 0.53125ZM9.9999 17.7303C8.99459 17.7418 7.99697 17.5537 7.06485 17.177C6.13272 16.8003 5.2846 16.2423 4.56962 15.5355C3.85465 14.8287 3.28702 13.987 2.89961 13.0593C2.51221 12.1315 2.31273 11.1361 2.31273 10.1308C2.31273 9.12537 2.51221 8.12998 2.89961 7.20223C3.28702 6.27449 3.85465 5.43283 4.56962 4.726C5.2846 4.01918 6.13272 3.46124 7.06485 3.0845C7.99697 2.70777 8.99459 2.51972 9.9999 2.53125C11.0052 2.51972 12.0028 2.70777 12.935 3.0845C13.8671 3.46124 14.7152 4.01918 15.4302 4.726C16.1452 5.43283 16.7128 6.27449 17.1002 7.20223C17.4876 8.12998 17.6871 9.12537 17.6871 10.1308C17.6871 11.1361 17.4876 12.1315 17.1002 13.0593C16.7128 13.987 16.1452 14.8287 15.4302 15.5355C14.7152 16.2423 13.8671 16.8003 12.935 17.177C12.0028 17.5537 11.0052 17.7418 9.9999 17.7303ZM7.5009 9.88125C8.3289 9.88125 8.9999 9.09825 8.9999 8.13125C8.9999 7.16425 8.3279 6.38125 7.4999 6.38125C6.6719 6.38125 5.9999 7.16425 5.9999 8.13125C5.9999 9.09825 6.6719 9.88125 7.5009 9.88125ZM12.4999 9.88125C13.3289 9.88125 13.9999 9.09825 13.9999 8.13125C13.9999 7.16425 13.3279 6.38125 12.4999 6.38125C11.6719 6.38125 10.9999 7.16525 10.9999 8.13125C10.9999 9.09725 11.6719 9.88125 12.4999 9.88125ZM14.3409 11.4673C14.1644 11.3782 13.9601 11.3618 13.7716 11.4217C13.5832 11.4815 13.4257 11.6127 13.3329 11.7873C13.2989 11.8533 12.4639 13.3802 10.0009 13.3802C7.5499 13.3802 6.7099 11.8673 6.6679 11.7882C6.57799 11.6107 6.42123 11.4761 6.2321 11.4141C6.04297 11.3522 5.83696 11.3678 5.6594 11.4578C5.48184 11.5477 5.34727 11.7044 5.28528 11.8936C5.2233 12.0827 5.23899 12.2887 5.3289 12.4663C5.3789 12.5653 6.5769 14.8802 10.0009 14.8802C13.4259 14.8802 14.6219 12.5642 14.6709 12.4653C14.759 12.2891 14.7738 12.0852 14.7119 11.8981C14.6501 11.7111 14.5167 11.5562 14.3409 11.4673Z"
        fill="#FF6C00"
      />
    </g>
    <defs>
      <clipPath id="clip0_110_88821">
        <rect
          width="20"
          height="20"
          fill="white"
          transform="translate(0 0.130859)"
        />
      </clipPath>
    </defs>
  </svg>
);
export const BadIcon: React.FC<CustomSVGBaseType> = ({ className }) => (
  <svg
    className={className}
    width="20"
    height="21"
    viewBox="0 0 20 21"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M10 18.8809C7.67936 18.8809 5.45376 17.959 3.81282 16.318C2.17187 14.6771 1.25 12.4515 1.25 10.1309C1.25 7.81021 2.17187 5.58462 3.81282 3.94368C5.45376 2.30273 7.67936 1.38086 10 1.38086C12.3206 1.38086 14.5462 2.30273 16.1872 3.94368C17.8281 5.58462 18.75 7.81021 18.75 10.1309C18.75 12.4515 17.8281 14.6771 16.1872 16.318C14.5462 17.959 12.3206 18.8809 10 18.8809ZM10 20.1309C12.6522 20.1309 15.1957 19.0773 17.0711 17.2019C18.9464 15.3266 20 12.783 20 10.1309C20 7.47869 18.9464 4.93516 17.0711 3.05979C15.1957 1.18443 12.6522 0.130859 10 0.130859C7.34784 0.130859 4.8043 1.18443 2.92893 3.05979C1.05357 4.93516 0 7.47869 0 10.1309C0 12.783 1.05357 15.3266 2.92893 17.2019C4.8043 19.0773 7.34784 20.1309 10 20.1309Z"
      fill="#2F2F2F"
    />
    <path
      d="M5.35594 15.6721C5.49949 15.755 5.67008 15.7774 5.83019 15.7345C5.9903 15.6916 6.12681 15.5869 6.20969 15.4434C6.59358 14.7779 7.14601 14.2254 7.81135 13.8414C8.4767 13.4574 9.23147 13.2554 9.99969 13.2559C11.6184 13.2559 13.0322 14.1346 13.7897 15.4434C13.8732 15.5857 14.0096 15.6893 14.1691 15.7315C14.3287 15.7737 14.4984 15.7511 14.6414 15.6685C14.7843 15.586 14.8888 15.4503 14.932 15.291C14.9753 15.1317 14.9538 14.9618 14.8722 14.8184C14.3786 13.9629 13.6684 13.2526 12.813 12.7589C11.9576 12.2651 10.9873 12.0054 9.99969 12.0059C9.01211 12.0057 8.04188 12.2655 7.18656 12.7592C6.33124 13.2529 5.62098 13.9631 5.12719 14.8184C5.04431 14.9619 5.02185 15.1325 5.06475 15.2926C5.10765 15.4527 5.21239 15.5892 5.35594 15.6721ZM8.74969 8.25586C8.74969 9.29086 8.18969 10.1309 7.49969 10.1309C6.80969 10.1309 6.24969 9.29086 6.24969 8.25586C6.24969 7.22086 6.80969 6.38086 7.49969 6.38086C8.18969 6.38086 8.74969 7.22086 8.74969 8.25586ZM13.7497 8.25586C13.7497 9.29086 13.1897 10.1309 12.4997 10.1309C11.8097 10.1309 11.2497 9.29086 11.2497 8.25586C11.2497 7.22086 11.8097 6.38086 12.4997 6.38086C13.1897 6.38086 13.7497 7.22086 13.7497 8.25586Z"
      fill="#2F2F2F"
    />
  </svg>
);
export const NormalIcon: React.FC<CustomSVGBaseType> = ({ className }) => (
  <svg
    className={className}
    width="20"
    height="21"
    viewBox="0 0 20 21"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M10 18.8809C7.67936 18.8809 5.45376 17.959 3.81282 16.318C2.17187 14.6771 1.25 12.4515 1.25 10.1309C1.25 7.81021 2.17187 5.58462 3.81282 3.94368C5.45376 2.30273 7.67936 1.38086 10 1.38086C12.3206 1.38086 14.5462 2.30273 16.1872 3.94368C17.8281 5.58462 18.75 7.81021 18.75 10.1309C18.75 12.4515 17.8281 14.6771 16.1872 16.318C14.5462 17.959 12.3206 18.8809 10 18.8809ZM10 20.1309C12.6522 20.1309 15.1957 19.0773 17.0711 17.2019C18.9464 15.3266 20 12.783 20 10.1309C20 7.47869 18.9464 4.93516 17.0711 3.05979C15.1957 1.18443 12.6522 0.130859 10 0.130859C7.34784 0.130859 4.8043 1.18443 2.92893 3.05979C1.05357 4.93516 0 7.47869 0 10.1309C0 12.783 1.05357 15.3266 2.92893 17.2019C4.8043 19.0773 7.34784 20.1309 10 20.1309Z"
      fill="#FFAA45"
    />
    <path
      d="M5 13.2559C5 13.4216 5.06585 13.5806 5.18306 13.6978C5.30027 13.815 5.45924 13.8809 5.625 13.8809H14.375C14.5408 13.8809 14.6997 13.815 14.8169 13.6978C14.9342 13.5806 15 13.4216 15 13.2559C15 13.0901 14.9342 12.9311 14.8169 12.8139C14.6997 12.6967 14.5408 12.6309 14.375 12.6309H5.625C5.45924 12.6309 5.30027 12.6967 5.18306 12.8139C5.06585 12.9311 5 13.0901 5 13.2559ZM8.75 8.25586C8.75 7.22086 8.19 6.38086 7.5 6.38086C6.81 6.38086 6.25 7.22086 6.25 8.25586C6.25 9.29086 6.81 10.1309 7.5 10.1309C8.19 10.1309 8.75 9.29086 8.75 8.25586ZM13.75 8.25586C13.75 7.22086 13.19 6.38086 12.5 6.38086C11.81 6.38086 11.25 7.22086 11.25 8.25586C11.25 9.29086 11.81 10.1309 12.5 10.1309C13.19 10.1309 13.75 9.29086 13.75 8.25586Z"
      fill="#FFAA45"
    />
  </svg>
);
export const XIcon: React.FC<CustomSVGBaseType> = ({ className }) => (
  <svg
    className={className}
    width="8"
    height="8"
    viewBox="0 0 8 8"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M7 1L1 7M1 1L7 7"
      stroke="#333333"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export const ArrowDown: React.FC<CustomSVGBaseType> = ({ className }) => (
  <svg
    className={className}
    width="14"
    height="9"
    viewBox="0 0 14 9"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M1 1.5L7 7.5L13 1.5"
      stroke="#7A7B7A"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <text x="0" y="0" font-size="24pt">
      xem thêm
    </text>
  </svg>
);
export const ArrowUp: React.FC<CustomSVGBaseType> = ({ className }) => (
  <svg
    className={className}
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12 8.29492L6 14.2949L7.41 15.7049L12 11.1249L16.59 15.7049L18 14.2949L12 8.29492Z"
      fill="black"
    />
  </svg>
);
export const ArrowDownIcon: React.FC<CustomSVGBaseType> = ({ className }) => (
  <svg
    className={className}
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M16.59 8.29492L12 12.8749L7.41 8.29492L6 9.70492L12 15.7049L18 9.70492L16.59 8.29492Z"
      fill="black"
    />
  </svg>
);
export const ChatOrder: React.FC<CustomSVGBaseType> = ({ className }) => (
  <svg
    className={className}
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M19 9.50003C19.0034 10.8199 18.6951 12.1219 18.1 13.3C17.3944 14.7118 16.3098 15.8992 14.9674 16.7293C13.6251 17.5594 12.0782 17.9994 10.5 18C9.18013 18.0035 7.87812 17.6951 6.7 17.1L1 19L2.9 13.3C2.30493 12.1219 1.99656 10.8199 2 9.50003C2.00061 7.92179 2.44061 6.37488 3.27072 5.03258C4.10083 3.69028 5.28825 2.6056 6.7 1.90003C7.87812 1.30496 9.18013 0.996587 10.5 1.00003H11C13.0843 1.11502 15.053 1.99479 16.5291 3.47089C18.0052 4.94699 18.885 6.91568 19 9.00003V9.50003Z"
      stroke="#161C24"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export const ComplainIcon: React.FC<CustomSVGBaseType> = ({ className }) => (
  <svg
    className={className}
    width="24"
    height="25"
    viewBox="0 0 24 25"
    fill="currentcolor"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M20.8387 8.18289C21.2287 7.79289 21.2287 7.16289 20.8387 6.77289L18.0087 3.94289C17.6187 3.55289 16.9887 3.55289 16.5987 3.94289L12.1087 8.43289L8.21865 4.54289C7.43865 3.76289 6.16865 3.76289 5.38865 4.54289L3.48865 6.44289C2.70865 7.22289 2.70865 8.49289 3.48865 9.27289L7.37865 13.1629L2.86865 17.6729V21.9129H7.10865L11.6287 17.3929L15.5187 21.2829C16.4687 22.2329 17.7487 21.8829 18.3487 21.2829L20.2487 19.3829C21.0287 18.6029 21.0287 17.3329 20.2487 16.5529L16.3587 12.6629L20.8387 8.18289ZM4.90865 7.85289L6.79865 5.95289L8.06865 7.22289L6.88865 8.41289L8.29865 9.82289L9.48865 8.63289L10.6887 9.83289L8.78865 11.7329L4.90865 7.85289ZM16.1387 15.2929L14.9487 16.4829L16.3587 17.8929L17.5487 16.7029L18.8187 17.9729L16.9187 19.8729L13.0287 15.9829L14.9287 14.0829L16.1387 15.2929ZM6.27865 19.9129H4.86865V18.5029L14.4787 8.89289L15.8887 10.3029L6.27865 19.9129ZM15.8887 7.47289L17.2987 6.06289L18.7087 7.47289L17.2987 8.88289L15.8887 7.47289Z"
      fill="currentcolor"
    />
  </svg>
);
export const Paperclip: React.FC<CustomSVGBaseType> = ({ className }) => (
  <svg
    width="19"
    height="20"
    viewBox="0 0 19 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M17.8666 9.2081L10.2082 16.8664C9.27005 17.8046 7.99757 18.3317 6.67075 18.3317C5.34393 18.3317 4.07145 17.8046 3.13325 16.8664C2.19505 15.9282 1.66797 14.6558 1.66797 13.3289C1.66797 12.0021 2.19505 10.7296 3.13325 9.79144L10.7916 2.1331C11.4171 1.50763 12.2654 1.15625 13.1499 1.15625C14.0345 1.15625 14.8828 1.50763 15.5082 2.1331C16.1337 2.75857 16.4851 3.60689 16.4851 4.49144C16.4851 5.37598 16.1337 6.2243 15.5082 6.84977L7.84158 14.5081C7.52885 14.8208 7.10469 14.9965 6.66242 14.9965C6.22014 14.9965 5.79598 14.8208 5.48325 14.5081C5.17051 14.1954 4.99482 13.7712 4.99482 13.3289C4.99482 12.8867 5.17051 12.4625 5.48325 12.1498L12.5582 5.0831"
      stroke="#9D9D9D"
      strokeWidth="2"
      stroke-linecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export const OpenIcon: React.FC<CustomSVGBaseType> = ({ className }) => (
  <svg
    className={className}
    width="16"
    height="17"
    viewBox="0 0 16 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M7 10.2656C6.90114 10.2656 6.80452 10.2362 6.72234 10.1813C6.64015 10.1263 6.5761 10.0483 6.53828 9.95694C6.50045 9.8656 6.49055 9.7651 6.50983 9.66814C6.5291 9.57118 6.57668 9.48211 6.64656 9.41219L11.5822 4.47656C11.3268 4.33787 11.0407 4.26535 10.75 4.26563H3.25C2.78602 4.26612 2.34119 4.45066 2.01311 4.77874C1.68503 5.10682 1.5005 5.55165 1.5 6.01563V13.5156C1.5005 13.9796 1.68503 14.4244 2.01311 14.7525C2.34119 15.0806 2.78602 15.2651 3.25 15.2656H10.75C11.214 15.2651 11.6588 15.0806 11.9869 14.7525C12.315 14.4244 12.4995 13.9796 12.5 13.5156V6.01563C12.5003 5.72497 12.4278 5.43887 12.2891 5.18344L7.35344 10.1191C7.30711 10.1656 7.25203 10.2025 7.19137 10.2277C7.13071 10.2528 7.06567 10.2657 7 10.2656Z"
      fill="black"
    />
    <path
      d="M14 2.26562H10.5C10.3674 2.26562 10.2402 2.3183 10.1464 2.41207C10.0527 2.50584 10 2.63302 10 2.76562C10 2.89823 10.0527 3.02541 10.1464 3.11918C10.2402 3.21295 10.3674 3.26562 10.5 3.26562H12.7928L11.5822 4.47656C11.8812 4.63895 12.1267 4.88447 12.2891 5.18344L13.5 3.97281V6.26562C13.5 6.39823 13.5527 6.52541 13.6464 6.61918C13.7402 6.71295 13.8674 6.76562 14 6.76562C14.1326 6.76562 14.2598 6.71295 14.3536 6.61918C14.4473 6.52541 14.5 6.39823 14.5 6.26562V2.76562C14.5 2.63302 14.4473 2.50584 14.3536 2.41207C14.2598 2.3183 14.1326 2.26563 14 2.26562Z"
      fill="black"
    />
  </svg>
);
export const SuccessIcon: React.FC<CustomSVGBaseType> = ({ className }) => (
  <svg
    className={className}
    width="20"
    height="21"
    viewBox="0 0 20 21"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M15.5917 6.77384C15.5142 6.69574 15.4221 6.63374 15.3205 6.59143C15.219 6.54913 15.11 6.52734 15 6.52734C14.89 6.52734 14.7811 6.54913 14.6796 6.59143C14.578 6.63374 14.4858 6.69574 14.4084 6.77384L8.20004 12.9905L5.59171 10.3738C5.51127 10.2961 5.41632 10.235 5.31227 10.194C5.20823 10.153 5.09713 10.1329 4.98531 10.1349C4.87349 10.1368 4.76315 10.1607 4.66058 10.2053C4.55802 10.2499 4.46524 10.3142 4.38754 10.3947C4.30984 10.4751 4.24875 10.5701 4.20774 10.6741C4.16674 10.7782 4.14663 10.8893 4.14856 11.0011C4.1505 11.1129 4.17444 11.2232 4.21902 11.3258C4.2636 11.4284 4.32794 11.5211 4.40837 11.5988L7.60837 14.7988C7.68584 14.8769 7.77801 14.9389 7.87956 14.9813C7.98111 15.0236 8.09003 15.0453 8.20004 15.0453C8.31005 15.0453 8.41897 15.0236 8.52052 14.9813C8.62207 14.9389 8.71424 14.8769 8.79171 14.7988L15.5917 7.99884C15.6763 7.92081 15.7438 7.8261 15.79 7.72068C15.8361 7.61526 15.86 7.50143 15.86 7.38634C15.86 7.27126 15.8361 7.15742 15.79 7.052C15.7438 6.94659 15.6763 6.85188 15.5917 6.77384Z"
      fill="#5BD523"
    />
  </svg>
);
export const DoubleArrowDown: React.FC<CustomSVGBaseType> = ({ className }) => (
  <svg
    className={className}
    width="10"
    height="12"
    viewBox="0 0 10 12"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M10 1.34102L8.825 0.166016L5 3.98268L1.175 0.166016L0 1.34102L5 6.34102L10 1.34102Z"
      fill="currentColor"
    />
    <path
      d="M10 6.83268L8.825 5.65768L5 9.47435L1.175 5.65768L0 6.83268L5 11.8327L10 6.83268Z"
      fill="currentColor"
    />
  </svg>
);
export const DownloadIcon1: React.FC<CustomSVGBaseType> = ({ className }) => (
  <svg
    className={className}
    width="25"
    height="24"
    viewBox="0 0 25 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M21.5 15V19C21.5 19.5304 21.2893 20.0391 20.9142 20.4142C20.5391 20.7893 20.0304 21 19.5 21H5.5C4.96957 21 4.46086 20.7893 4.08579 20.4142C3.71071 20.0391 3.5 19.5304 3.5 19V15"
      stroke="white"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M7.5 10L12.5 15L17.5 10"
      stroke="white"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M12.5 15V3"
      stroke="white"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export const SearchSVG: React.FC<CustomSVGBaseType> = ({ className }) => (
  <svg
    className={className}
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M5 11C5 7.691 7.691 5 11 5C14.309 5 17 7.691 17 11C17 14.309 14.309 17 11 17C7.691 17 5 14.309 5 11ZM20.707 19.293L17.312 15.897C18.365 14.543 19 12.846 19 11C19 6.589 15.411 3 11 3C6.589 3 3 6.589 3 11C3 15.411 6.589 19 11 19C12.846 19 14.543 18.365 15.897 17.312L19.293 20.707C19.488 20.902 19.744 21 20 21C20.256 21 20.512 20.902 20.707 20.707C21.098 20.316 21.098 19.684 20.707 19.293Z"
      fill="#637381"
    />
    <mask
      id="mask0_276_25006"
      style={{ maskType: 'alpha' }}
      maskUnits="userSpaceOnUse"
      x="3"
      y="3"
      width="19"
      height="18"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5 11C5 7.691 7.691 5 11 5C14.309 5 17 7.691 17 11C17 14.309 14.309 17 11 17C7.691 17 5 14.309 5 11ZM20.707 19.293L17.312 15.897C18.365 14.543 19 12.846 19 11C19 6.589 15.411 3 11 3C6.589 3 3 6.589 3 11C3 15.411 6.589 19 11 19C12.846 19 14.543 18.365 15.897 17.312L19.293 20.707C19.488 20.902 19.744 21 20 21C20.256 21 20.512 20.902 20.707 20.707C21.098 20.316 21.098 19.684 20.707 19.293Z"
        fill="white"
      />
    </mask>
    <g mask="url(#mask0_276_25006)">
      <rect width="24" height="24" fill="#637381" />
    </g>
  </svg>
);
export const QuestionMarkIcon: React.FC<CustomSVGBaseType> = ({
  className,
}) => (
  <svg
    className={className}
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M8.16699 13.9993H9.83366V12.3327H8.16699V13.9993ZM9.00033 0.666016C4.40033 0.666016 0.666992 4.39935 0.666992 8.99935C0.666992 13.5993 4.40033 17.3327 9.00033 17.3327C13.6003 17.3327 17.3337 13.5993 17.3337 8.99935C17.3337 4.39935 13.6003 0.666016 9.00033 0.666016ZM9.00033 15.666C5.32533 15.666 2.33366 12.6743 2.33366 8.99935C2.33366 5.32435 5.32533 2.33268 9.00033 2.33268C12.6753 2.33268 15.667 5.32435 15.667 8.99935C15.667 12.6743 12.6753 15.666 9.00033 15.666ZM9.00033 3.99935C7.15866 3.99935 5.66699 5.49102 5.66699 7.33268H7.33366C7.33366 6.41602 8.08366 5.66602 9.00033 5.66602C9.91699 5.66602 10.667 6.41602 10.667 7.33268C10.667 8.99935 8.16699 8.79102 8.16699 11.4993H9.83366C9.83366 9.62435 12.3337 9.41602 12.3337 7.33268C12.3337 5.49102 10.842 3.99935 9.00033 3.99935Z"
      fill="#9D9D9D"
    />
  </svg>
);
export const AccountIcon: React.FC<CustomSVGBaseType> = ({ className }) => (
  <svg
    className={className}
    width="24"
    height="25"
    viewBox="0 0 24 25"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12 2.76562C6.48 2.76562 2 7.24563 2 12.7656C2 18.2856 6.48 22.7656 12 22.7656C17.52 22.7656 22 18.2856 22 12.7656C22 7.24563 17.52 2.76562 12 2.76562ZM7.07 19.0456C7.5 18.1456 10.12 17.2656 12 17.2656C13.88 17.2656 16.51 18.1456 16.93 19.0456C15.57 20.1256 13.86 20.7656 12 20.7656C10.14 20.7656 8.43 20.1256 7.07 19.0456ZM18.36 17.5956C16.93 15.8556 13.46 15.2656 12 15.2656C10.54 15.2656 7.07 15.8556 5.64 17.5956C4.62 16.2556 4 14.5856 4 12.7656C4 8.35563 7.59 4.76562 12 4.76562C16.41 4.76562 20 8.35563 20 12.7656C20 14.5856 19.38 16.2556 18.36 17.5956ZM12 6.76562C10.06 6.76562 8.5 8.32562 8.5 10.2656C8.5 12.2056 10.06 13.7656 12 13.7656C13.94 13.7656 15.5 12.2056 15.5 10.2656C15.5 8.32562 13.94 6.76562 12 6.76562ZM12 11.7656C11.17 11.7656 10.5 11.0956 10.5 10.2656C10.5 9.43563 11.17 8.76562 12 8.76562C12.83 8.76562 13.5 9.43563 13.5 10.2656C13.5 11.0956 12.83 11.7656 12 11.7656Z"
      fill="#7A7B7A"
    />
  </svg>
);
export const PopularQuestionIcon: React.FC<CustomSVGBaseType> = ({
  className,
}) => (
  <svg
    className={className}
    width="24"
    height="25"
    viewBox="0 0 24 25"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M20.8391 8.16727C21.2291 7.77727 21.2291 7.14727 20.8391 6.75727L18.0091 3.92727C17.6191 3.53727 16.9891 3.53727 16.5991 3.92727L12.1091 8.41727L8.21914 4.52727C7.43914 3.74727 6.16914 3.74727 5.38914 4.52727L3.48914 6.42727C2.70914 7.20727 2.70914 8.47727 3.48914 9.25727L7.37914 13.1473L2.86914 17.6573V21.8973H7.10914L11.6291 17.3773L15.5191 21.2673C16.4691 22.2173 17.7491 21.8673 18.3491 21.2673L20.2491 19.3673C21.0291 18.5873 21.0291 17.3173 20.2491 16.5373L16.3591 12.6473L20.8391 8.16727ZM4.90914 7.83727L6.79914 5.93727L8.06914 7.20727L6.88914 8.39727L8.29914 9.80727L9.48914 8.61727L10.6891 9.81727L8.78914 11.7173L4.90914 7.83727ZM16.1391 15.2773L14.9491 16.4673L16.3591 17.8773L17.5491 16.6873L18.8191 17.9573L16.9191 19.8573L13.0291 15.9673L14.9291 14.0673L16.1391 15.2773ZM6.27914 19.8973H4.86914V18.4873L14.4791 8.87727L15.8891 10.2873L6.27914 19.8973ZM15.8891 7.45727L17.2991 6.04727L18.7091 7.45727L17.2991 8.86727L15.8891 7.45727Z"
      fill="#333333"
    />
  </svg>
);
export const SupportIcon: React.FC<CustomSVGBaseType> = ({ className }) => (
  <svg
    className={className}
    width="24"
    height="25"
    viewBox="0 0 24 25"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M11 18.7656H13V16.7656H11V18.7656ZM12 2.76562C6.48 2.76562 2 7.24563 2 12.7656C2 18.2856 6.48 22.7656 12 22.7656C17.52 22.7656 22 18.2856 22 12.7656C22 7.24563 17.52 2.76562 12 2.76562ZM12 20.7656C7.59 20.7656 4 17.1756 4 12.7656C4 8.35563 7.59 4.76562 12 4.76562C16.41 4.76562 20 8.35563 20 12.7656C20 17.1756 16.41 20.7656 12 20.7656ZM12 6.76562C9.79 6.76562 8 8.55562 8 10.7656H10C10 9.66563 10.9 8.76562 12 8.76562C13.1 8.76562 14 9.66563 14 10.7656C14 12.7656 11 12.5156 11 15.7656H13C13 13.5156 16 13.2656 16 10.7656C16 8.55562 14.21 6.76562 12 6.76562Z"
      fill="currentColor"
    />
  </svg>
);
export const ComplainTicket: React.FC<CustomSVGBaseType> = ({ className }) => (
  <svg
    className={className}
    width="24"
    height="25"
    viewBox="0 0 24 25"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M4.08496 18.2656V17.6156C4.08496 17.2756 4.24496 16.9556 4.49496 16.8056C6.18496 15.7956 8.11496 15.2656 10.085 15.2656C10.115 15.2656 10.135 15.2656 10.165 15.2756C10.265 14.5756 10.465 13.9056 10.755 13.2956C10.535 13.2756 10.315 13.2656 10.085 13.2656C7.66496 13.2656 5.40496 13.9356 3.47496 15.0856C2.59496 15.6056 2.08496 16.5856 2.08496 17.6156V20.2656H11.345C10.925 19.6656 10.595 18.9856 10.375 18.2656H4.08496Z"
      fill="#7A7B7A"
    />
    <path
      d="M10.085 12.2656C12.295 12.2656 14.085 10.4756 14.085 8.26562C14.085 6.05562 12.295 4.26562 10.085 4.26562C7.87496 4.26562 6.08496 6.05562 6.08496 8.26562C6.08496 10.4756 7.87496 12.2656 10.085 12.2656ZM10.085 6.26562C11.185 6.26562 12.085 7.16563 12.085 8.26562C12.085 9.36562 11.185 10.2656 10.085 10.2656C8.98496 10.2656 8.08496 9.36562 8.08496 8.26562C8.08496 7.16563 8.98496 6.26562 10.085 6.26562Z"
      fill="#7A7B7A"
    />
    <path
      d="M20.835 16.2656C20.835 16.0456 20.805 15.8456 20.775 15.6356L21.915 14.6256L20.915 12.8956L19.465 13.3856C19.145 13.1156 18.785 12.9056 18.385 12.7556L18.085 11.2656H16.085L15.785 12.7556C15.385 12.9056 15.025 13.1156 14.705 13.3856L13.255 12.8956L12.255 14.6256L13.395 15.6356C13.365 15.8456 13.335 16.0456 13.335 16.2656C13.335 16.4856 13.365 16.6856 13.395 16.8956L12.255 17.9056L13.255 19.6356L14.705 19.1456C15.025 19.4156 15.385 19.6256 15.785 19.7756L16.085 21.2656H18.085L18.385 19.7756C18.785 19.6256 19.145 19.4156 19.465 19.1456L20.915 19.6356L21.915 17.9056L20.775 16.8956C20.805 16.6856 20.835 16.4856 20.835 16.2656ZM17.085 18.2656C15.985 18.2656 15.085 17.3656 15.085 16.2656C15.085 15.1656 15.985 14.2656 17.085 14.2656C18.185 14.2656 19.085 15.1656 19.085 16.2656C19.085 17.3656 18.185 18.2656 17.085 18.2656Z"
      fill="#7A7B7A"
    />
  </svg>
);
export const ChatIconSider: React.FC<CustomSVGBaseType> = ({ className }) => (
  <svg
    className={className}
    width="24"
    height="25"
    viewBox="0 0 24 25"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M22 8.74563V17.7656C22 18.8656 21.1 19.7656 20 19.7656H6L2 23.7656V5.76562C2 4.66563 2.9 3.76562 4 3.76562H14.1C14.04 4.08562 14 4.42563 14 4.76562C14 5.10562 14.04 5.44563 14.1 5.76562H4V17.7656H20V9.66563C20.74 9.51562 21.42 9.18563 22 8.74563ZM16 4.76562C16 6.42562 17.34 7.76562 19 7.76562C20.66 7.76562 22 6.42562 22 4.76562C22 3.10563 20.66 1.76562 19 1.76562C17.34 1.76562 16 3.10563 16 4.76562Z"
      fill="#7A7B7A"
    />
  </svg>
);
export const ArrowNextIcon: React.FC<CustomSVGBaseType> = ({ className }) => (
  <svg
    className={className}
    width="20"
    height="24"
    viewBox="0 0 20 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M10 6L8.94 7.06L13.13 11.25H4V12.75H13.13L8.94 16.94L10 18L16 12L10 6Z"
      fill="#FF6C00"
    />
  </svg>
);
export const EditIcon: React.FC<CustomSVGBaseType> = ({
  className,
  onClick,
}) => (
  <svg
    className={className}
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    onClick={onClick}
  >
    <path
      d="M14.059 9.02L14.979 9.94L5.91902 19H4.99902V18.08L14.059 9.02ZM17.659 3C17.409 3 17.149 3.1 16.959 3.29L15.129 5.12L18.879 8.87L20.709 7.04C21.099 6.65 21.099 6.02 20.709 5.63L18.369 3.29C18.169 3.09 17.919 3 17.659 3ZM14.059 6.19L2.99902 17.25V21H6.74902L17.809 9.94L14.059 6.19Z"
      fill="black"
    />
  </svg>
);

export const EditNoteIcon: React.FC<CustomSVGBaseType> = ({ className }) => (
  <svg
    className={className}
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M2.93375 8.5H13.9337V10.5H2.93375V8.5ZM2.93375 6.5H13.9337V4.5H2.93375V6.5ZM2.93375 14.5H9.93375V12.5H2.93375V14.5ZM17.9437 11.37L18.6537 10.66C19.0437 10.27 19.6737 10.27 20.0637 10.66L20.7737 11.37C21.1637 11.76 21.1637 12.39 20.7737 12.78L20.0637 13.49L17.9437 11.37ZM17.2337 12.08L11.9337 17.38V19.5H14.0537L19.3537 14.2L17.2337 12.08Z"
      fill="#9D9D9D"
    />
  </svg>
);
export const CameraBlurIcon: React.FC<CustomSVGBaseType> = ({ className }) => (
  <svg
    className={className}
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12.0833 3.33398H7.91663L5.83329 5.83398H3.33329C2.89127 5.83398 2.46734 6.00958 2.15478 6.32214C1.84222 6.6347 1.66663 7.05862 1.66663 7.50065V15.0007C1.66663 15.4427 1.84222 15.8666 2.15478 16.1792C2.46734 16.4917 2.89127 16.6673 3.33329 16.6673H16.6666C17.1087 16.6673 17.5326 16.4917 17.8451 16.1792C18.1577 15.8666 18.3333 15.4427 18.3333 15.0007V7.50065C18.3333 7.05862 18.1577 6.6347 17.8451 6.32214C17.5326 6.00958 17.1087 5.83398 16.6666 5.83398H14.1666L12.0833 3.33398Z"
      stroke="currentColor"
      strokeWidth="1.74459"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M10 13.332C11.3807 13.332 12.5 12.2127 12.5 10.832C12.5 9.45132 11.3807 8.33203 10 8.33203C8.61929 8.33203 7.5 9.45132 7.5 10.832C7.5 12.2127 8.61929 13.332 10 13.332Z"
      stroke="currentColor"
      strokeWidth="1.74459"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export const BackIcon: React.FC<CustomSVGBaseType> = ({ className }) => (
  <svg
    className={className}
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M0 10C0 15.52 4.48 20 10 20C15.52 20 20 15.52 20 10C20 4.48 15.52 0 10 0C4.48 0 0 4.48 0 10ZM18 10C18 14.42 14.42 18 10 18C5.58 18 2 14.42 2 10C2 5.58 5.58 2 10 2C14.42 2 18 5.58 18 10ZM6 10L10 6L11.41 7.41L9.83 9H14V11H9.83L11.42 12.59L10 14L6 10Z"
      fill="#7A7B7A"
    />
  </svg>
);
export const AddImageIcon: React.FC<CustomSVGBaseType> = ({ className }) => (
  <svg
    className={className}
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M16 2V16H2V2H16ZM16 0H2C0.9 0 0 0.9 0 2V16C0 17.1 0.9 18 2 18H16C17.1 18 18 17.1 18 16V2C18 0.9 17.1 0 16 0ZM11.14 8.86L8.14 12.73L6 10.14L3 14H15L11.14 8.86Z"
      fill="#7A7B7A"
    />
  </svg>
);
export const CloseChatIcon: React.FC<CustomSVGBaseType> = ({ className }) => (
  <svg
    className={className}
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M10 0C4.47 0 0 4.47 0 10C0 15.53 4.47 20 10 20C15.53 20 20 15.53 20 10C20 4.47 15.53 0 10 0ZM10 18C5.59 18 2 14.41 2 10C2 5.59 5.59 2 10 2C14.41 2 18 5.59 18 10C18 14.41 14.41 18 10 18ZM13.59 5L10 8.59L6.41 5L5 6.41L8.59 10L5 13.59L6.41 15L10 11.41L13.59 15L15 13.59L11.41 10L15 6.41L13.59 5Z"
      fill="#7A7B7A"
    />
  </svg>
);
export const AddIconChat: React.FC<CustomSVGBaseType> = ({ className }) => (
  <svg
    className={className}
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M13.5 9C14.3284 9 15 8.32843 15 7.5C15 6.67157 14.3284 6 13.5 6C12.6716 6 12 6.67157 12 7.5C12 8.32843 12.6716 9 13.5 9Z"
      fill="#9D9D9D"
    />
    <path
      d="M6.5 9C7.32843 9 8 8.32843 8 7.5C8 6.67157 7.32843 6 6.5 6C5.67157 6 5 6.67157 5 7.5C5 8.32843 5.67157 9 6.5 9Z"
      fill="#9D9D9D"
    />
    <path
      d="M10 16C12.28 16 14.22 14.34 15 12H5C5.78 14.34 7.72 16 10 16Z"
      fill="#9D9D9D"
    />
    <path
      d="M9.99 0C4.47 0 0 4.48 0 10C0 15.52 4.47 20 9.99 20C15.52 20 20 15.52 20 10C20 4.48 15.52 0 9.99 0ZM10 18C5.58 18 2 14.42 2 10C2 5.58 5.58 2 10 2C14.42 2 18 5.58 18 10C18 14.42 14.42 18 10 18Z"
      fill="#9D9D9D"
    />
  </svg>
);
export const MoreChatIcon: React.FC<CustomSVGBaseType> = ({ className }) => (
  <svg
    className={className}
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M10 0C4.48 0 0 4.48 0 10C0 15.52 4.48 20 10 20C15.52 20 20 15.52 20 10C20 4.48 15.52 0 10 0ZM10 18C5.58 18 2 14.42 2 10C2 5.58 5.58 2 10 2C14.42 2 18 5.58 18 10C18 14.42 14.42 18 10 18Z"
      fill="#7A7B7A"
    />
    <path
      d="M5 11.5C5.82843 11.5 6.5 10.8284 6.5 10C6.5 9.17157 5.82843 8.5 5 8.5C4.17157 8.5 3.5 9.17157 3.5 10C3.5 10.8284 4.17157 11.5 5 11.5Z"
      fill="#7A7B7A"
    />
    <path
      d="M10 11.5C10.8284 11.5 11.5 10.8284 11.5 10C11.5 9.17157 10.8284 8.5 10 8.5C9.17157 8.5 8.5 9.17157 8.5 10C8.5 10.8284 9.17157 11.5 10 11.5Z"
      fill="#7A7B7A"
    />
    <path
      d="M15 11.5C15.8284 11.5 16.5 10.8284 16.5 10C16.5 9.17157 15.8284 8.5 15 8.5C14.1716 8.5 13.5 9.17157 13.5 10C13.5 10.8284 14.1716 11.5 15 11.5Z"
      fill="#7A7B7A"
    />
  </svg>
);
export const OrderIcon: React.FC<CustomSVGBaseType> = ({ className }) => (
  <svg
    className={className}
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M16 2V16H2V2H16ZM16 0H2C0.9 0 0 0.9 0 2V16C0 17.1 0.9 18 2 18H16C17.1 18 18 17.1 18 16V2C18 0.9 17.1 0 16 0Z"
      fill="#7A7B7A"
    />
    <path
      d="M11 14H4V12H11V14ZM14 10H4V8H14V10ZM14 6H4V4H14V6Z"
      fill="#7A7B7A"
    />
  </svg>
);
export const SendChatIcon: React.FC<CustomSVGBaseType> = ({ className }) => (
  <svg
    className={className}
    width="22"
    height="18"
    viewBox="0 0 22 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M2.51 3.03L10.02 6.25L2.5 5.25L2.51 3.03ZM10.01 11.75L2.5 14.97V12.75L10.01 11.75ZM0.51 0L0.5 7L15.5 9L0.5 11L0.51 18L21.5 9L0.51 0Z"
      fill="#7A7B7A"
    />
  </svg>
);
export const TripIcon: React.FC<CustomSVGBaseType> = ({ className }) => (
  <svg
    className={className}
    width="16"
    height="20"
    viewBox="0 0 16 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M16 2H2V0H0V20H2V12H16L14 7L16 2ZM12.14 7.74L13.04 10H2V4H13.05L12.15 6.26L11.85 7L12.14 7.74ZM9 7C9 8.1 8.1 9 7 9C5.9 9 5 8.1 5 7C5 5.9 5.9 5 7 5C8.1 5 9 5.9 9 7Z"
      fill="#7A7B7A"
    />
  </svg>
);

export const ToolIcon: React.FC<CustomSVGBaseType> = ({ className }) => (
  <svg
    className={className}
    width="24"
    height="25"
    viewBox="0 0 24 25"
    fill="currentcolor"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M14.7001 7.06536C14.5169 7.25229 14.4142 7.50361 14.4142 7.76536C14.4142 8.02711 14.5169 8.27843 14.7001 8.46536L16.3001 10.0654C16.487 10.2486 16.7383 10.3512 17.0001 10.3512C17.2619 10.3512 17.5132 10.2486 17.7001 10.0654L21.4701 6.29536C21.9729 7.40655 22.1252 8.6446 21.9066 9.84451C21.6879 11.0444 21.1088 12.1492 20.2464 13.0116C19.3839 13.8741 18.2792 14.4532 17.0792 14.6718C15.8793 14.8904 14.6413 14.7382 13.5301 14.2354L6.6201 21.1454C6.22227 21.5432 5.68271 21.7667 5.1201 21.7667C4.55749 21.7667 4.01792 21.5432 3.6201 21.1454C3.22227 20.7475 2.99878 20.208 2.99878 19.6454C2.99878 19.0827 3.22227 18.5432 3.6201 18.1454L10.5301 11.2354C10.0273 10.1242 9.87502 8.88613 10.0936 7.68622C10.3123 6.4863 10.8914 5.38152 11.7538 4.51908C12.6163 3.65665 13.721 3.07753 14.921 2.8589C16.1209 2.64028 17.3589 2.79253 18.4701 3.29536L14.7101 7.05536L14.7001 7.06536Z"
      fill="currentcolor"
      stroke="#7A7B7A"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export const BellIcon: React.FC<SvgIconBaseProps> = ({ color, ...rest }) => {
  return (
    <svg
      {...rest}
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_4439_36339)">
        <path
          d="M15 6.66663C15 5.34054 14.4732 4.06877 13.5355 3.13109C12.5979 2.19341 11.3261 1.66663 10 1.66663C8.67392 1.66663 7.40215 2.19341 6.46447 3.13109C5.52678 4.06877 5 5.34054 5 6.66663C5 12.5 2.5 14.1666 2.5 14.1666H17.5C17.5 14.1666 15 12.5 15 6.66663Z"
          stroke={color || '#333333'}
          strokeWidth="2"
          stroke-linecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M11.4417 17.5C11.2952 17.7526 11.0849 17.9622 10.8319 18.1079C10.5789 18.2537 10.292 18.3304 10 18.3304C9.70803 18.3304 9.42117 18.2537 9.16816 18.1079C8.91515 17.9622 8.70486 17.7526 8.55835 17.5"
          stroke={color || '#333333'}
          strokeWidth="2"
          stroke-linecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M1.66675 6.66663C1.66675 4.83329 2.25008 3.08329 3.33341 1.66663"
          stroke={color || '#333333'}
          strokeWidth="2"
          stroke-linecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M18.3334 6.66663C18.3334 4.86354 17.7486 3.10909 16.6667 1.66663"
          stroke={color || '#333333'}
          strokeWidth="2"
          stroke-linecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_4439_36339">
          <rect width="20" height="20" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
export const FlagIcon: React.FC<CustomSVGBaseType> = ({ className }) => (
  <svg
    className={className}
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="25"
    viewBox="0 0 24 25"
    fill="currentcolor"
  >
    <path
      d="M11.86 6.26562L12.26 8.26562H17.5V14.2656H14.14L13.74 12.2656H6.5V6.26562H11.86ZM13.5 4.26562H4.5V21.2656H6.5V14.2656H12.1L12.5 16.2656H19.5V6.26562H13.9L13.5 4.26562Z"
      fill="currentcolor"
    />
  </svg>
);
